import React from "react";

import Stack from "veneer/Stack";
import styled from "veneer/styled";
import { Colors } from "veneer/Theme";
import Tooltip from "veneer/Tooltip";
import Typography from "veneer/Typography";

import { getLastConnectedStatusMeta } from "cortex/ui/src/constant/lastConnected";
import { Indicator } from "cortex/ui/src/ui/indicator";

import type { DeviceLastSeen } from "../model";

interface LastConnectedProps {
  lastSeen: DeviceLastSeen | null;
}

const Wrapper = styled(Stack)({
  cursor: "default",
});

export default function LastConnected({ lastSeen }: LastConnectedProps) {
  const status = getLastConnectedStatusMeta(lastSeen);

  const tooltipTitle = (
    <>
      {status.tooltipTitle}
      {status.tooltipSubtitle && (
        <>
          <br />
          {status.tooltipSubtitle}
        </>
      )}
    </>
  );

  return (
    <Tooltip title={tooltipTitle}>
      <Wrapper>
        <Stack alignItems="center" direction="row" gap={0.5}>
          <Indicator color={status.color} type={status.icon} />
          <Typography color={Colors.gray1000} fontWeight="bold" variant="h6">
            {status.label}
          </Typography>
        </Stack>
        <Typography ml={2.5} variant="body2">
          {status.sublabel}
        </Typography>
      </Wrapper>
    </Tooltip>
  );
}
